// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3psSi","icon":"SortAdornment_icon__1INVE","up":"SortAdornment_up__4Pg_C","down":"SortAdornment_down__1wEOV","active":"SortAdornment_active__3ugRU"};